import React from 'react';

const Redirect = () =>{
    return(
        <React.Fragment>
            <div className = 'container ml-5'>
                <div className = 'row'>
                    Features of the website - 
                    <ul>
                        <li>Mobile Freindly using Reactstrap</li>
                        <li>Working Links using React Router Dom</li>
                        <li>Easy to Update - just add components</li>
                    </ul>
                </div>
                <div className = 'row'>
                   <b><i>Made by Harsh Verma, VIT</i></b> 
                </div>

            </div>
        </React.Fragment>
    );
}
export default Redirect;